export default [
  // { header: "GESTÃO EDUCACIONAL" },
  // { icon: "pages", title: "Blank Page", name: "BlankPage" },
  // {
  //   icon: "fas fa-file",
  //   title: "Document",
  //   href: "http://doc-vuse-v1.hexesis.com",
  //   target: "_blank"
  // },
  {
    icon: "account_box",
    title: "Usuários",
    name: "UsuariosPage",
    menu: "usuarios"
  },
  {
    icon: "group",
    title: "Pessoas",
    name: "GerenciaCadastroPessoas",
    menu: "pessoas"
  },
  {
    icon: "school",
    title: "Cursos",
    name: "GerenciaCadastroCursos",
    menu: "cursos"
  },
  {
    icon: "book",
    title: "Disciplinas",
    name: "GerenciaCadastroDisciplinas",
    menu: "disciplinas"
  },
  {
    icon: "collections_bookmark",
    title: "Matrículas",
    name: "GerenciaCadastroMatriculas",
    menu: "matriculas"
  },
  {
    icon: "library_books",
    title: "Contratos",
    name: "GerenciaCadastroContratos",
    menu: "contratos"
  },
  {
    icon: "date_range",
    title: "Calendário",
    name: "GerenciaCadastroCalendario",
    menu: "calendarios"
  },
  {
    icon: "av_timer",
    title: "Horários",
    name: "GerenciaCadastroHorarios",
    menu: "horarios"
  },
  {
    icon: "domain",
    title: "Estutura Ano Letivo",
    name: "GerenciaCadastroEstruturaAnoLetivo",
    menu: "estruturas_anos_letivos"
  },
  {
    icon: "account_balance",
    title: "Estutura Pedagógica",
    name: "GerenciaCadastroEstrutraPedagogica",
    menu: "estruturas_pedagogicas"
  },
  {
    icon: "featured_play_list",
    title: "Plano Pedagógico",
    name: "GerenciaCadastroPlanoPedagogico",
    menu: "planos_pedagogicos"
  },
  {
    icon: "insert_invitation",
    title: "Diário/Frequência",
    name: "GerenciaCadastroDiario",
    menu: "diarios"
  },
  // {
  //   icon: "playlist_add_check",
  //   title: "Frequência",
  //   name: "GerenciaCadastroFrequencia",
  //   menu: "frequencias"
  // },
  {
    icon: "event_available",
    title: "Avaliação",
    name: "GerenciaCadastroAvaliacao",
    menu: "avaliacoes"
  },
  {
    icon: "speaker_notes",
    title: "Resultados",
    name: "GerenciaResultadoAvaliacaoPorHabilidade",
    menu: "resultados_avaliacoes_habilidades"
  },
  {
    icon: "playlist_add",
    title: "Tipos Ocorrências",
    name: "GerenciaCadastroTiposOcorrencias",
    menu: "tipos_ocorrencias"
  },
  {
    icon: "event_note",
    title: "Ocorrências",
    name: "GerenciaCadastroOcorrencias",
    menu: "ocorrencias"
  },
  {
    icon: "assignment_turned_in",
    title: "Atestados",
    name: "GerenciaCadastroAtestados",
    menu: "atestados"
  },
  {
    icon: "directions_walk",
    title: "Funcionários",
    name: "GerenciaCadastroFuncionario",
    menu: "funcionarios"
  },
  {
    icon: "schedule",
    title: "Pontos",
    name: "GerenciaCadastroPontos",
    menu: "pontos"
  },
  {
    icon: "done_all",
    title: "Homologação Pontos",
    name: "GerenciaCadastroHomologacaoPonto",
    menu: "homologacao_pontos"
  },
  {
    icon: "archive",
    title: "Relatórios Pedagógicos",
    name: "GerenciaRelatorioPedagogico",
    menu: "relatorios_pedagogicos"
  },
  {
    icon: "archive",
    title: "Relatórios Alunos",
    name: "GerenciaRelatorioAlunos",
    menu: "relatorios_alunos"
  },
  {
    icon: "speaker_notes",
    title: "Resultados Bimestres",
    name: "GerenciaResultadoBimestre",
    menu: "resultados_bimestres"
  },
  {
    icon: "pin_drop",
    title: "Itineários",
    name: "GerenciaCadastroItinerariosFormativos",
    menu: "itinerarios"
  },
  {
    icon: "schedule",
    title: "Plano Quadro Horário",
    name: "GerenciaCadastroQhPlanos",
    menu: "qh_planos"
  },
  {
    icon: "event_note",
    title: "Previsão Quadro Horário",
    name: "GerenciaCadastroQhPrevisoes",
    menu: "qh_previsoes"
  },
  {
    icon: "event_busy",
    title: "Recesso Quadro Horário",
    name: "GerenciaCadastroQhRecessos",
    menu: "qh_recessos"
  },
  {
    icon: "event_available",
    title: "Atividade Extra Quadro Horário",
    name: "GerenciaCadastroQhAtvExtras",
    menu: "qh_atv_extras"
  },
  {
    icon: "assignment",
    title: "Relatório Quadro Horário",
    name: "GerenciaRelatorioQuadroHorario",
    menu: "qh_relatorios"
  }
];
